import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Feild_startDate, SUB_TYPE, USER_TYPE, validity_date_v2 } from 'src/app/core/Constants/static';
import { RuleConfigListing } from 'src/app/core/Models/interfaces/ruleconfig';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { ProvPayerApiService } from '../../../provider_insurance/services/prov-payer-api.service';
import { RuleConfigManageService } from '../../services/rule-config-manage.service';
import { environment } from 'src/environments/environment';
import { PayerList } from 'src/app/core/Models/interfaces/payerList';
import { ProviderDetails } from 'src/app/core/Models/interfaces/providerDetails';
import { RuleConfigFilter } from 'src/app/core/Models/interfaces/payloads/ruleConfigFilter';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';

@Component({
  selector: 'app-rule-configurations',
  templateUrl: './rule-configurations.component.html',
  styleUrls: ['./rule-configurations.component.css']
})
export class RuleConfigurationsComponent implements OnInit {

  @ViewChildren('focusedElement') focusedElement!: QueryList<ElementRef>;

  private page_limit: number = 10;
  private sortParams!: string;
  private payerId!: number | string;
  private providerId!: number | string;

  public showConfigurationEdit: boolean = false;
  public showConfigurationDetails: boolean = false;
  public subTypes = SUB_TYPE;
  public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
  public filterationForm!: FormGroup;
  public totalCount!: number;
  public page_no: number = 1;
  public showNavigation: boolean = false;
  public ruleConfigList: RuleConfigListing[] = [];
  public user?: UserDetails;
  public isAddPage: boolean = false;
  public providerList: ProviderDetails[] = [];
  public payerList: PayerList[] = [];
  public selectedConfig!: RuleConfigListing;
  public versionSort!: string;
  public feild_startDate = validity_date_v2;
  public listHead = 'Provider';
  private subscriberType!:string
  public columnSort: Record<string, { sortType: string, clicked: boolean }> = {
    SubscriberName: {
      sortType: 'ascending',
      clicked: false
    },
    // payerName: {
    //   sortType: 'ascending',
    //   clicked: false

    // },
    // providerName: {
    //   sortType: 'ascending',
    //   clicked: false

    // },
    activeFrom: {
      sortType: 'ascending',
      clicked: false

    },
    version: {
      sortType: 'ascending',
      clicked: false

    },
    payerRuleConfigurationVersion: {
      sortType: 'ascending',
      clicked: false

    },
    providerRuleConfigurationVersion: {
      sortType: 'ascending',
      clicked: false

    }
  }

  constructor(private toasterandLoader: ToasterService,
    private ruleService: RuleConfigManageService,
    private userService: UserService,
    private provPayerApiService: ProvPayerApiService) {
    this.user = this.userService.getUserInfo()?.userDetails;
  }

  public ngOnInit(): void {
    this.createFilterForm();
  }

  private createFilterForm(): void {
    this.filterationForm = new FormGroup({
      version: new FormControl(null),
      validity: new FormControl(null),
      subType: new FormControl('provider'),
      payerId: new FormControl(null),
      providerId: new FormControl(null),
      inUse: new FormControl(null)

    });
    if (this.subTypeEvm == this.subTypes.provider ) {
      this.filterationForm.controls['subType'].setValue('provider');
      this.filterationForm.controls['subType'].disable();
    }
    else if (this.subTypeEvm == this.subTypes.payer ) {
      this.filterationForm.controls['subType'].setValue('payer');
      this.filterationForm.controls['subType'].disable();
    }
    else{
      this.filterationForm.controls['subType'].setValue('provider');
      if(this.user?.userType == USER_TYPE.payer){
        this.filterationForm.controls['subType'].setValue('payer');
      }
    }
    if(this.filterationForm.getRawValue().subType == 'provider'){
      this.getProviderList();
    }else if(this.filterationForm.getRawValue().subType == 'payer'){
      this.getPayersList();
    }
    
    this.payerId=this.user?.payerId||'';
    this.providerId=this.user?.providerId||'';
  }

  private getProviderList(): void {
    this.subscriberType='provider';
    // this.listHead = 'Provider';
    if (!this.providerList.length && this.checkPermission('getProvider') && (this.user?.userType == USER_TYPE.provider || this.user?.userType == USER_TYPE.system)) {
      this.provPayerApiService.getProviderList().subscribe({
        next: (response) => {
          if (response) {
            this.providerList = response?.data?.data;
          }
        },
        error: (error) => {

        },
      })
    }
  }

  private getPayersList(): void {
    this.subscriberType='payer';
    // this.listHead = 'Payer';

    if (!this.payerList.length && this.checkPermission('getPayer') && (this.user?.userType == USER_TYPE.payer  || this.user?.userType == USER_TYPE.system)) {
      this.provPayerApiService.getPayerList().subscribe({
        next: (response) => {
          if (response) {
            this.payerList = response?.data?.data;
          }
        },
        error: (error) => {

        },
      })
    }
  }

  public handleChange(event: Event): void {
    if ((event?.target as HTMLInputElement)?.value == 'payer') {
      this.getPayersList();
    } else {
      this.getProviderList()
    }
  }

  public onApply(): void {
    this.page_no = 1;
    this.providerId = '';
    this.payerId = '';
    this.applyFilter();
  }

  public onReset(): void {
    this.filterationForm.reset();
    this.providerId = '';
    this.payerId = '';
    if (this.subTypeEvm == this.subTypes.provider || this.subTypeEvm == this.subTypes.both ) {
      this.filterationForm?.controls?.['subType'].patchValue('provider');
      this.getProviderList();
    } 
    else {
      this.filterationForm?.controls?.['subType'].patchValue('payer');
      this.getPayersList();
    }

    this.sortParams = '';
    this.page_limit = 10;
    this.page_no = 1;
    this.totalCount = 1;
    this.showNavigation = false;
    this.applyFilter();
  }

  public applyFilter():void {
    this.toasterandLoader.isLoaderEnable(true);
    const validity = this.filterationForm?.value?.validity;
    const valStart = validity?.substring(0, validity.indexOf(' '));
    const parts: string[] = validity?.split(' ');
    const valEnd = parts?.pop();
    const validityStart = valStart?.split("/").reverse().join("-");
    const validityEndDate = valEnd?.split("/").reverse().join("-");
    let subscriberType=null; 
    // if(this.user?.userType==2){
    //   subscriberType=2;
    // }else if(this.user?.userType==3){
    //   subscriberType=3;
    // }

    if (this.filterationForm?.controls['subType']?.value === 'provider') {
      // subscriberType=2;
      this.listHead = 'Provider';
      this.providerId = this.filterationForm?.controls['providerId']?.value?.providerId || this.user?.providerId;
      this.versionSort = 'providerRuleConfigurationVersion';
      this.filterationForm?.controls['payerId']?.reset();
    } 
    else {
      // subscriberType=3;
      this.listHead = 'Payer';
      this.payerId = this.filterationForm?.controls['payerId']?.value?.payerId || this.user?.payerId;
      this.versionSort = 'payerRuleConfigurationVersion';
      this.filterationForm?.controls['providerId']?.reset();
    }
    const payLoad: RuleConfigFilter = {
      per_page: this.page_limit,
      page: this.page_no,
      isActive: this.filterationForm?.controls?.['inUse']?.value ? '1' : '',
      sort: this.sortParams,
      activeFrom: validityStart ? validityStart : '',
      expiredOn: validityEndDate ? validityEndDate : '',
      payerId: this.payerId || '',
      providerId: this.providerId || '',
      subscriberType: subscriberType,
      version:this.filterationForm?.controls?.['version']?.value || '',
      // providerRuleConfigurationVersion: this.subscriberType == 'provider'? this.filterationForm?.controls?.['version']?.value : '',
      // payerRuleConfigurationVersion: this.subscriberType == 'payer' ? this.filterationForm?.controls?.['version']?.value : '',
    }
    if (this.filterationForm?.controls['subType']?.value === 'provider') {
      this.getProviderRuleList(payLoad);
    }
    else {
      this.getPayerRuleList(payLoad);
    }
  }

  private getProviderRuleList(payload: RuleConfigFilter) {
    this.ruleService.getRuleConfigListProvider(this.user?.providerId, payload).subscribe({
      next: (response) => {
        if (response) {
          this.ruleConfigList = response?.data?.data;
          this.totalCount = response?.data?.total;
          if (!this.ruleConfigList.length) this.showNavigation = true;
          this.toasterandLoader.isLoaderEnable(false);
        }
      },
      error: (error) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: error?.message,
        });
        this.toasterandLoader.isLoaderEnable(false);
      },
    })

  }

  private getPayerRuleList(payload: RuleConfigFilter) {
    this.ruleService.getRuleConfigListPayer(this.user?.payerId, payload).subscribe({
      next: (response) => {
        if (response) {
          this.ruleConfigList = response?.data?.data;
          this.totalCount = response?.data?.total;
          if (!this.ruleConfigList.length) this.showNavigation = true;
          this.toasterandLoader.isLoaderEnable(false);
        }
      },
      error: (error) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: error?.message,
        });
        this.toasterandLoader.isLoaderEnable(false);
      },
    })

  }

  public configurationEdit(item: RuleConfigListing): void {
    this.showConfigurationEdit = true;
    this.selectedConfig = item;
    this.isAddPage = false;
  }

  public manageEdit(): void {
    this.showConfigurationDetails = false;
    this.showConfigurationEdit = true;
    this.selectedConfig = this.selectedConfig;
    this.isAddPage = false;
  }

  public configurationAdd(): void {
    this.showConfigurationEdit = true;
    this.isAddPage = true;
  }

  public configurationDetails(item: RuleConfigListing): void {
    this.showConfigurationDetails = true;
    this.selectedConfig = item;

  }

  private isScrollIntoViewNeeded(): void {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }

  public currentPageDetail(event: Pagination): void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.applyFilter();

  }

  public sortColumn(colName: string): void {
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        const element = this.columnSort[key];
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.applyFilter();
        } else {
          this.columnSort[key].sortType = 'ascending';
        }

      }
    }
  }

  public isInUseChecked(event: Event): void {
    return;
  }

  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

}
